var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M0.119452 4.82121L3.79481 8.86714C3.95608 9.04429 4.21737 9.04429 4.37904 8.86714C4.54032 8.69 4.54032 8.40227 4.37904 8.22513L0.995215 4.50022L4.37864 0.77532C4.53991 0.598177 4.53991 0.31045 4.37864 0.132858C4.21737 -0.0442851 3.95567 -0.0442852 3.7944 0.132858L0.119044 4.17875C-0.0397503 4.35406 -0.0397504 4.64631 0.119452 4.82121Z",
    fill: "#29185E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrLeft);
export default __webpack_public_path__ + "static/media/arr-left.6bf3d2dd75c3b86e844083ab1f03b9fd.svg";
export { ForwardRef as ReactComponent };